const supportedLocales = {
  it: 'Italiano'
}

export function supportedLocalesInclude(locale) {
  return Object.keys(supportedLocales).includes(locale)
}



// WEBPACK FOOTER //
// ./src/lang/_supported-locales.js